module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABLAgMAAAD7dsokAAAACVBMVEUAnmD80RY6dcR21W9yAAAAH0lEQVR4AWNhwAXoKjMqMyoTOhoGozKjKXFUZlQGBgAUowHXPv21gQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/ga.png
// module id = BbHv
// module chunks = 0